import { Grid, Typography } from '@mui/material';
import AppContainer from 'src/components/appComponents/AppContainer';
import { paths } from 'src/routes/paths';
import AddMarketingForm from 'src/sections/marketing/AddMarketingForm';

export default function AddMarketingPage() {
  return (
    <AppContainer
      pageTitle="Add Marketing"
      routeLinks={[
        { name: 'Marketing', href: paths.dashboard.marketing.root },
        { name: 'Add Marketing' },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} mb={4}>
          <Typography variant="h4" color="primary">
            Marketing info
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <AddMarketingForm />
        </Grid>
      </Grid>
    </AppContainer>
  );
}
